import { ErrorMessage, Field, Form, Formik } from 'formik';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { Button, Card, FormGroup } from 'reactstrap';
import * as Yup from 'yup';

import style from '../../styles/layout.module.css';
import request from '../../utils/useAxios';
import Loader from '../Loader';



const RecruitmentPage = () => {
  const [data, setData] = useState(null);

  const getPageText = useCallback(async () => {
    const res = await request({
      method: 'get',
      url: '/Backend/Cafe_Recruitment/pageText',
    });
    if (res.code === 200) {
      return res.result || {};
    } else {
      return {};
    }
  }, []);

  const savePageText = useCallback(
    async (
      data = {
        content: '',
        content_en: '',
      },
    ) => {
      setData(null);
      const res = await request({
        data,
        method: 'post',
        url: '/Backend/Cafe_Recruitment/pageText/save',
      });
      if (res.code === 200) {
        getPageText().then(data => {
          setData(data);
        });
      } else {
        setData(data);
      }
    },
    [],
  );

  const getValidationSchema = () => {
    const schema = Yup.object().shape({
      content: Yup.string().required('必填!'),
      content_en: Yup.string().required('必填!'),
    });
    return schema;
  };

  useEffect(() => {
    getPageText().then(data => {
      setData(data);
    });
  }, []);

  if (!data) {
    return <Loader />;
  }
  return (
    <Card className={`${style.search_card} ${style['seo-card-layout']}`}>
      <Formik
        enableReinitialize
        initialValues={{
          content: data.content || '',
          content_en: data.content_en || '',
        }}
        validationSchema={getValidationSchema}
      >
        {props => (
          <Form className="form-list form-label-140">
            <FormGroup className="form-group mb-3 mb-3">
              <label>*中文</label>
              <div className="form-item">
                <Field
                  name="content"
                  className="form-control"
                  component="textarea"
                  row="5"
                />
                <ErrorMessage
                  name="content"
                  component="div"
                  className="form-error"
                />
              </div>
            </FormGroup>
            <FormGroup className="form-group mb-3 mb-3">
              <label>*英文</label>
              <div className="form-item">
                <Field
                  name="content_en"
                  className="form-control"
                  component="textarea"
                  row="5"
                />
                <ErrorMessage
                  name="content_en"
                  component="div"
                  className="form-error"
                />
              </div>
            </FormGroup>
            <div style={{ minHeight: '150px' }}></div>
            <p className="fs-14">
              {props.values.updateDateTime} {props.values.updater}
            </p>
            <hr />
            <div className="text-center">
              <Button
                type="button"
                className={style.modal_button_submit}
                disabled={!(props.isValid && props.dirty)}
                onClick={() => {
                  savePageText(props.values);
                }}
              >
                <span className="btn-wrapper--label">儲存</span>
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </Card>
  );
};

export default memo(RecruitmentPage);
